import React from 'react';
import { useState, useEffect } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { getEpoch } from '../utils';

export default function QuizTimer(props) {

	const { startedAt, endsAt } = props;
	
	const endEpoch = getEpoch(endsAt);
	const startEpoch = getEpoch(startedAt);

	const [nowEpoch, setNowEpoch] = useState(getEpoch());

	const total = endEpoch - startEpoch;
	let remaining = endEpoch - nowEpoch;

	if (remaining > total) {
		remaining = total;
	}

	const remainingPercent = ((remaining / total) * 100).toFixed(2);
	const remainingMinutesAndSeconds = Math.floor(remaining / 60) + ":" + String(remaining % 60).padStart(2, "0");

	useEffect(() => 
	{
		const timer = setTimeout(() => {
			setNowEpoch(getEpoch());
		}, 1000);

		return () => clearTimeout(timer);
	});

	useEffect(() => 
	{
		if (typeof props.onUpdated === "function") 
		{
			props.onUpdated({
				remaining,
				remainingPercent,
				remainingMinutesAndSeconds
			});
		}

		if (remaining <= 0 && typeof props.onElapsed === "function") {
			props.onElapsed();
		}

	}, [props, remaining, remainingPercent, remainingMinutesAndSeconds])

	const label = `Tid kvar (${remainingMinutesAndSeconds})`;

	return (
		<div className={props.classNames}>
			<ProgressBar label={label} now={remainingPercent} />
		</div>
	);
}